import { Injectable } from '@angular/core';

import { EditorPage } from 'src/app/pages/editor/editor.page';

import { ConfirmDialogService } from 'src/app/shared/ui/confirm-dialog/confirm-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class PipelineCanDeactivateGuard {

  constructor(private confirmDialog: ConfirmDialogService) {}

  async canDeactivate(component: EditorPage): Promise<boolean> {
    if (!component.pipeline?.dirty) return true;
    return this.confirmDialog.confirm({
      header: 'Confirm',
      message: 'You have unsaved changes. Are you sure you want to leave?',
      confirmText: 'Leave',
    });
  }
}
